import { stammdatenComplete } from '@/core/api/team'
import { ApiError } from '@/core/api/http'

export type StammdatenCompleteResult = { complete: boolean }

export async function completeStammdatenAsStaff(coachingId: string): Promise<StammdatenCompleteResult> {
  try {
    await stammdatenComplete(coachingId)
    return { complete: true }
  } catch (error) {
    if (error instanceof ApiError && error.status === 409) return { complete: false }
    throw error
  }
}
